export default {
  'booking-settings': {
    'booking-rules': 'Booking Rules',
    'booking-mode': {
      title: 'Automatically confirm bookings',
      description: 'When you turn on automatic confirmations, you save time and make it easier for your clients to book. Booksy recommends it.',
      'hint-1': 'When you turn on automatic confirmations, you save time and make it easier for your clients to book. Booksy recommends it.',
      'hint-2': 'If you do not turn on automatic confirmations, you will need to take time throughout the day to check your bookings and confirm them.',
      'hint-3': 'Not only is this a waste of your time, it also means more than one client can request the same time while waiting for you to confirm.',
    },
    'time-slots-optimization': {
      title: 'Avoid gaps between services',
      description: 'Schedule Optimization adjusts your available time slots to remove gaps in your calendar.',
    },
    'booking-min-lead-time': {
      label: 'Booking window',
      hint: 'How much of a window do you need between the time of booking and the appointment time? This helps you plan ahead and eliminates any surprise appointments.',
      options: {
        'minutes-15': 'No less than 15 minutes in advance',
        'minutes-30': 'No less than 30 minutes in advance',
        'hour-1': 'No less than 1 hour in advance',
        'hours-2': 'No less than 2 hours in advance',
        'hours-3': 'No less than 3 hours in advance',
        'hours-6': 'No less than 6 hours in advance',
        'hours-12': 'No less than 12 hours in advance',
        'day-1': 'No less than 1 day in advance',
        'days-2': 'No less than 2 days in advance',
        'days-3': 'No less than 3 days in advance',
        'days-4': 'No less than 4 days in advance',
        'days-5': 'No less than 5 days in advance',
        'days-7': 'No less than 7 days in advance',
        'days-10': 'No less than 10 days in advance',
        'days-14': 'No less than 14 days in advance',
      },
    },
    'booking-max-lead-time': {
      label: 'Future booking window',
      hint: 'Choose how far in the future clients can schedule appointments. Three months or more encourages return bookings and more stable earnigns.',
      options: {
        'days-7': 'up to 7 days in the future',
        'days-14': 'up to 14 days in the future',
        'month-1': 'up to 1 month in the future',
        'months-2': 'up to 2 months in the future',
        'months-3': 'up to 3 months in the future',
        'months-6': 'up to 6 months in the future',
        'months-12': 'up to 12 months in the future',
        'months-24': 'up to 24 months in the future',
      },
    },
    'booking-max-modification-time': {
      label: 'Rescheduling',
      hint: 'Choose how long before an appointment a client can reschedule.',
      options: {
        'hour-1': 'No less than 1 hour in advance',
        'hours-2': 'No less than 2 hours in advance',
        'hours-3': 'No less than 3 hours in advance',
        'hours-6': 'No less than 6 hours in advance',
        'hours-12': 'No less than 12 hours in advance',
        'day-1': 'No less than 1 day in advance',
        'days-2': 'No less than 2 days in advance',
        'days-3': 'No less than 3 days in advance',
        'days-4': 'No less than 4 days in advance',
        'days-5': 'No less than 5 days in advance',
        'days-7': 'No less than 7 days in advance',
        'days-10': 'No less than 10 days in advance',
      },
    },
  },
  'pos-retail': {
    'title': 'Point of Sale & Retail',
    'retail-settings': 'Retail Settings',
    'enable-cash-register': 'Enable cash register',
    'enable-cash-register-hint': 'This feature allows you to control the cash flow in your shop and account for all checked out money.',
    'registers-max-opened': 'Maximum number of open cash registers',
    'registers-max-opened-hint': 'The number of Registers that can be open at the same time.',
    'registers-reopening': 'Reopening Closed Cash Registers',
    'registers-shared': 'Share Registers',
    'registers-shared-hint': 'Any Staff Member can use any of the open Cash Registers.',
    'enable-tips': 'Enable staff tips',
    'enable-stock-control': 'Enable stock control',
    'enable-stock-control-hint': 'Enabling this feature will allow you to both manually and automatically monitor inventory numbers as products are sold or stocked. Note: Booksy will always allow a product to be added to a cart, even if the inventory equals 0.',
    'tip-settings': 'Tips Settings',
    'tax-settings': 'Tax Settings',
    'default-tip': 'Default tip',
    'no-tip': 'No tip',
    'add-tip-rate': 'Add Tip Rate',
    'edit-tip-rate': 'Edit Tip Rate',
    'the-same-tip-rate': 'Tip rate exists. Please select other tip rate.',
    'tax-rates': 'Tax Rates',
    'default-service-tax': 'Default service tax',
    'default-tax-hint': 'Default tax rates will automatically be applied to newly added products/services. Pre-existing products/services will not be affected, unless you click \'Apply default tax for all\' or edit the tax manually on the individual product/service pages.',
    'default-product-tax': 'Default product tax',
    'default': 'Default',
    'tax-free': 'Tax Free',
    'add-tax-rate': 'Add Tax Rate',
    'set-receipt-footer': 'Set receipt footer',
    'receipt-footer': 'Receipt footer',
    'tip-rate': 'Tip rate',
    'tax-rate': 'Tax rate',
    'apply-default-to-services': 'Apply new default tax to all existing services?',
    'apply-default-to-products': 'Apply new default tax to all existing products?',
    'yes-apply': 'Yes, apply',
    'platform-fee': 'Platform Fee Settings',
  },
  'text-messages': {
    'free-text-messages-limit': 'You will be charged for text messages based on your usage above free text messages limit.',
    'clients-logged': 'Clients logged into the app will receive free push notifications from the app instead of text messages.',
    'current-plan': 'Current plan',
    'send-less': 'Send less text messages',
    'usage-current-billing-cycle': 'Usage in current billing cycle',
    'usage-last-billing-cycle': 'Usage in last billing cycle',
    'additional-marketing': 'Additional Marketing SMS cost this billing cycle',
    'message-free-limit': 'Message above free limit',
    'plan-includes': 'Plan includes 50 free text messages',
  },
  'internal-notifications': {
    'title-one': 'Set security warning',
    'title-two': 'Email Notifications',
    'description-one': 'Booksy protects your clients database. If any staff open too many contact details in a short period of time, system will send you a text message.',
    'description-two': 'Send information about appointments to the provided email addresses.',
    'incrementer-label': 'Security Treshold',
    'all': 'All',
    'all-staff-bookings': 'All Staff Bookings',
    'notifications-warning': 'You will lose push notifications assigned to email {email}',
    'save': 'save',
    'cancel': 'cancel',
    'send-events': 'Send events related to {staffer_name} to:',
    'add-notification': 'Add Notification',
    'dropdown-label': 'Send events related to',
    'input-label': 'Recepient email address',
    'phone-label': 'Phone number for alerts',
  },
  'fiscalization': {
    'printing-receipt': 'Printing receipts',
    'enable-printing': 'Enable receipt printing',
    'print-employee-name': 'Print the name and surname of the employee who is currently logged in on receipts',
    'open-cash-drawer': 'Open the cash drawer upon printing a receipt',
    'download': 'Download the access program',
    'step-by-step': 'Step by step',
    'instruction-enable': 'Enable receipt printing',
    'instruction-download': 'Click the "Download Access Program" button',
    'instruction-start-program': 'Start the access program on the computer',
    'instruction-start-printing': 'Go back to Booksy and start printing receipts and you\'re done!',
    'connection-title': 'Estabilishing a connection ...',
    'connection-desc': 'Waiting for a response <br/>from the access program',
    'active': 'active',
    'connected': 'connected',
    'disconnected': 'disconnected',
    'access-program': 'Access program',
    'fiscal-printer': 'Fiscal printer',
    'printer-not-found': 'Printer not found',
    'fiscal-printer-reports': 'Fiscal printer reports',
    'print': 'Print',
    'daily-report': 'Daily Report',
    'monthly-report': 'Monthly Report',
  },
}
